export default __webpack_public_path__ + "static/media/My schedule 2.34300610.png";